import React from 'react';
import { Link } from 'react-router-dom';
import { useTenant } from '@/contexts/TenantContext';
import TrustRow from '@/components/TrustRow';

export default function Footer() {
  const { tenantPath, branding } = useTenant();
  const storeName = branding?.name || 'Golfshop.fit';

  return (
    <>
      <TrustRow />
      <footer className="bg-[#2C3E2D] py-16">
      <div className="container mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <img src="/logo.png" alt={storeName} className="h-16 w-auto mb-4 rounded-full" />
            <p className="text-white/60 text-sm">Premium custom golf equipment for serious players who demand precision and performance.</p>
          </div>
          
          <div>
            <h4 className="text-sm font-bold text-[#D4A55A] uppercase tracking-wider mb-4">Shop</h4>
            <ul className="space-y-2">
              <li><Link to={tenantPath("/category/shafts")} className="text-white/70 hover:text-[#D4A55A] text-sm transition-colors">Custom Shafts</Link></li>
              <li><Link to={tenantPath("/category/drivers")} className="text-white/70 hover:text-[#D4A55A] text-sm transition-colors">Drivers</Link></li>
              <li><Link to={tenantPath("/category/irons")} className="text-white/70 hover:text-[#D4A55A] text-sm transition-colors">Irons</Link></li>
              <li><Link to={tenantPath("/category/wedges")} className="text-white/70 hover:text-[#D4A55A] text-sm transition-colors">Wedges</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-sm font-bold text-[#D4A55A] uppercase tracking-wider mb-4">Support</h4>
            <ul className="space-y-2">
              <li><Link to={tenantPath("/contact")} className="text-white/70 hover:text-[#D4A55A] text-sm transition-colors">Contact Us</Link></li>
              <li><Link to={tenantPath("/shipping")} className="text-white/70 hover:text-[#D4A55A] text-sm transition-colors">Shipping Info</Link></li>
              <li><Link to={tenantPath("/returns")} className="text-white/70 hover:text-[#D4A55A] text-sm transition-colors">Returns</Link></li>
              <li><Link to={tenantPath("/faq")} className="text-white/70 hover:text-[#D4A55A] text-sm transition-colors">FAQ</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-sm font-bold text-[#D4A55A] uppercase tracking-wider mb-4">Connect</h4>
            <ul className="space-y-2">
              <li><a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-[#D4A55A] text-sm transition-colors">Instagram</a></li>
              <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-[#D4A55A] text-sm transition-colors">Twitter</a></li>
              <li><a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-[#D4A55A] text-sm transition-colors">YouTube</a></li>
            </ul>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-white/10 text-center text-white/50 text-sm">
          <p>&copy; {new Date().getFullYear()} {storeName}. All rights reserved.</p>
        </div>
      </div>
    </footer>
    </>
  );
}
